import type { FormApi } from "@rvf/react";

type MyInputProps = {
  name: string;
  type: string;
  form: FormApi<any>;
};

export const RVFHiddenInput = ({ name, type, form }: MyInputProps) => {
  return (
    <>
      <input
        {...form.getInputProps(name, {
          hidden: true,
          type: type,
          id: name,
        })}
      />
      {form.error(name) && (
        <span className="text-xs text-rose-600 dark:text-rose-400">
          {form.error(name)}
        </span>
      )}
    </>
  );
};
